import React from 'react';
import { IconName, iconsMap } from './iconList';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: IconName;
}

export const Icon: React.FC<IconProps> = ({ icon, ...props }) => {
  const SvgIcon = iconsMap[icon];

  if (!SvgIcon) {
    console.error(`### icon not found `, icon);
    return null;
  }

  return <SvgIcon {...props} />;
};

export const IconList = () => {
  return (
    <div className='grid grid-cols-5 gap-1 bg-customBgColor'>
      {(Object.keys(iconsMap) as IconName[]).map((iconName) => {
        return (
          <div
            key={iconName}
            className='flex flex-col items-center gap-1 border p-1'
          >
            <Icon icon={iconName} color='#FFFFFF' />
            <div className='text-xs text-white'>{iconName}</div>
          </div>
        );
      })}
    </div>
  );
};
